<main>
  <p-toolbar styleClass="mb-4 gap-2 flex gap-2">
    <ng-template pTemplate="left">
      <div class="flex gap-4">
        <p-fileupload
          mode="basic"
          name="demo[]"
          chooseIcon="pi pi-upload"
          accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          (onSelect)="importOrder($event, 'jja')"
          [auto]="true"
          [disabled]="loading"
          chooseLabel="JJA"
        />
        <p-fileupload
          mode="basic"
          name="demo[]"
          chooseIcon="pi pi-upload"
          accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          (onSelect)="importOrder($event, 'koopman')"
          [auto]="true"
          [disabled]="loading"
          chooseLabel="Koopman"
        />
        <p-fileupload
          mode="basic"
          name="demo[]"
          chooseIcon="pi pi-upload"
          accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          (onSelect)="importOrder($event, 'fornor')"
          [auto]="true"
          [disabled]="loading"
          chooseLabel="Fornor"
        />
        <p-fileupload
          mode="basic"
          name="demo[]"
          chooseIcon="pi pi-upload"
          accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          (onSelect)="importOrder($event, 'item')"
          [auto]="true"
          [disabled]="loading"
          chooseLabel="Item"
        />
      </div>
    </ng-template>
  </p-toolbar>
  <h1>Koopman</h1>
  <div>Excel Factura.... Ejemplo: Factura 2801976_22-05-2025.xlsx</div>
  <h1>JJA</h1>
  <div>Excel descargado de la web. Ejemplo: 27933_0_656671.0.xlsx</div>
  <h1>Item</h1>
  <div>Excel descargado de la web. Ejemplo: P35025192.xlsx</div>
  <h1>Fornor</h1>
  <div>
    Excel recibido por email. Ejemplo: 17-04-25 FORNOR 250408361436085
    1ºPEDIDO.xlsx
  </div>
  <p-toast></p-toast>
  <div class="loading-overlay" *ngIf="loading">
    <div class="spinner"></div>
  </div>
</main>
